import { render, staticRenderFns } from "./sample-detail.vue?vue&type=template&id=47c8a10a"
import script from "./sample-detail.vue?vue&type=script&lang=js"
export * from "./sample-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports